"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEB_VITALS_EVENT_DETAILS = exports.WEB_VITALS_THRESHOLDS = exports.CLS_MULT = exports.ACTIVE_WEB_VITALS = exports.WEB_VITALS = void 0;
const web_vitals_1 = require("web-vitals");
const isWebVitalsMetricActive_1 = __importDefault(require("../web-vitals/isWebVitalsMetricActive"));
/** List of Web Vitals metrics supported by Client Profiler */
exports.WEB_VITALS = ['CLS', 'FID', 'INP', 'LCP', 'TTFB'];
/**
 * Subset of Web vitals metrics supported by Client Profiler that are also
 * supported by the current browser.
 */
exports.ACTIVE_WEB_VITALS = exports.WEB_VITALS.filter(metric => (0, isWebVitalsMetricActive_1.default)(metric));
/**
 * CLS is multiplied by a constant internally because we don't trust
 * graphite/Prometheus to handle fractions very well
 */
exports.CLS_MULT = 1000;
/**
 * Thresholds for supported Web Vitals metric ratings, i.e., "good", "needs
 * improvement", and "poor".
 *
 *   | Score                     | Rating                |
 *   |-------------------------- |-----------------------|
 *   | up to and including `good`| "good"                |
 *   | up to and including `ni`  | "needs improvement"   |
 *   | above `ni`                | "poor"                |
 *
 * All scores are expressed in milliseconds (ms), except for CLS which is in
 * "milli layout shifts" which is just the CLS score multiplied by a constant.
 *
 * @See
 *   - https://github.com/GoogleChrome/web-vitals#metricratingthresholds
 *   - https://github.com/WICG/layout-instability#layout-shift-score
 */
exports.WEB_VITALS_THRESHOLDS = {
    /** https://web.dev/cls/#what-is-a-good-cls-score */
    CLS: { good: web_vitals_1.CLSThresholds[0] * exports.CLS_MULT, ni: web_vitals_1.CLSThresholds[1] * exports.CLS_MULT },
    /** https://web.dev/fid/#what-is-a-good-fid-score */
    FID: { good: web_vitals_1.FIDThresholds[0], ni: web_vitals_1.FIDThresholds[1] },
    /** https://web.dev/inp/#what-is-a-good-inp-score */
    INP: { good: web_vitals_1.INPThresholds[0], ni: web_vitals_1.INPThresholds[1] },
    /** https://web.dev/lcp/#what-is-a-good-lcp-score */
    LCP: { good: web_vitals_1.LCPThresholds[0], ni: web_vitals_1.LCPThresholds[1] },
    /** https://web.dev/ttfb/#what-is-a-good-ttfb-score */
    TTFB: { good: web_vitals_1.TTFBThresholds[0], ni: web_vitals_1.TTFBThresholds[1] },
};
/**
 * Create a list of tracked event details for all Web Vitals metrics.
 *
 * @example
 * ```js
 * [
 *    {
 *      CLS: {
 *        graphiteName: 'CLS',
 *        thresholds: { delighted: 0.1, satisfied: 0.25 },
 *        dynamicEvent: false,
 *      },
 *    },
 *    { FID: { ... } },
 *    // ...
 * ]
 * ```
 *
 * @todo Register via `registerEvent()`. See PERF-836.
 */
exports.WEB_VITALS_EVENT_DETAILS = 
// Translate Web Vitals thresholds to event details objects
Object.keys(exports.WEB_VITALS_THRESHOLDS).map(metric => ({
    [metric]: {
        graphiteName: metric,
        thresholds: {
            delighted: exports.WEB_VITALS_THRESHOLDS[metric].good,
            satisfied: exports.WEB_VITALS_THRESHOLDS[metric].ni,
        },
        // Treat all Web Vitals as static events because their values are
        // determined by the `web-vitals` library and not by Client Profiler
        dynamicEvent: false,
    },
}));
